var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"login-card-template"},[_c('b-row',{attrs:{"align-h":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('img',{staticClass:"login-card-template-logo",attrs:{"src":require("../../assets/logos/original.png")}})])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }